import { cn } from '@app/utils/cn';
import { useTranslation } from 'react-i18next';

import { ProductSummaryItem } from './ProductSummaryItem';

interface Props {
  variantsCount: number;
  unitsCount: number;
  price: string | number;
  className?: string;
  layout?: 'vertical' | 'horizontal';
  disabled?: boolean;
}

export const CheckoutProductSummary = ({ variantsCount, unitsCount, price, className, layout = 'horizontal', disabled = false }: Props) => {
  const { t } = useTranslation(['products', 'common', 'totals']);

  return (
    <div
      className={cn(
        {
          'flex flex-col items-start': layout === 'vertical',
          'flex shrink-0 justify-center gap-x-5 gap-y-2 sm:justify-end': layout === 'horizontal',
          'opacity-50': disabled,
        },
        className,
      )}
    >
      <ProductSummaryItem label={t('totals:total_one')} value={price} layout="horizontal-reverse" />
      <div className="flex gap-3">
        <ProductSummaryItem
          label={`${t('products:variant', { count: variantsCount })}:`}
          value={variantsCount}
          layout={layout}
          valueSize="small"
        />
        <ProductSummaryItem label={`${t('common:unit', { count: unitsCount })}:`} value={unitsCount} layout={layout} valueSize="small" />
      </div>
    </div>
  );
};
